import {
  DatePicker,
  DatePickerProps,
  Calendar,
  CalendarProps,
  CalendarNavigationItem,
  CalendarNavigationItemProps
} from '@progress/kendo-react-dateinputs';
import React from 'react';

// Replacement text for year navigation in calendar.
const YEAR_REPLACEMENT_TEXT = 'Jan';

/**
 * Custom navigation item for Kendo DatePicker calendar.
 * Replaces the default year display with "Jan" in the calendar navigation header.
 */
const CustomNavigationItem = (props: CalendarNavigationItemProps) => {
  const text = props.text;
  const year = props.value.getFullYear();
  const month = props.value.toLocaleString('default', { month: 'long' });

  const isMonthlyView = props.view === 0; // view 0 corresponds to monthly view
  
  // Check if decade view or month view
  if (isMonthlyView && parseInt(props.text)) {

    return (
    <CalendarNavigationItem {...props}>
      <div title={`${month} ${year}`}>
      {YEAR_REPLACEMENT_TEXT}
      </div>
    </CalendarNavigationItem>
  );
  }

  return (
    <CalendarNavigationItem {...props}>
      <div title={isMonthlyView ? `${month} ${year}` : undefined}>
      {text}
      </div>
    </CalendarNavigationItem>
  );
};

const FlowinglyCalendar = (calendarProps: CalendarProps) => {
  return <Calendar {...calendarProps} navigationItem={CustomNavigationItem} />;
};

const KendoReactDatePicker = (props: DatePickerProps) => {
  return (
    <div className="kendo-react-date-picker">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <DatePicker {...props} calendar={FlowinglyCalendar} />
    </div>
  );
};

export default KendoReactDatePicker;

export type { DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
